import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import { LoadAddressSummariesSuccessAction, addressSummariesActionTypes} from '../actions/address-summaries';
import {AddressSummaries} from '../../shared/models/address';

export interface AddressSummariesState {
  addressSummaries: AddressSummaries[];
}

const initialState: AddressSummariesState = {
  addressSummaries: undefined
};

export function AddressSummariesReducer(state: AddressSummariesState = initialState, action: Action): AddressSummariesState {
  switch (action.type) {
    case addressSummariesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case addressSummariesActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case addressSummariesActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: AddressSummariesState, action: LoadAddressSummariesSuccessAction): AddressSummariesState {
  const newState: AddressSummariesState = {
    addressSummaries: action.payload.array
  };
  return newState;
}

function handleLoadClearActions(): AddressSummariesState {
  const newState: AddressSummariesState = {
    addressSummaries: undefined
  };
  return newState;
}

function handleLoadErrorActions(state: AddressSummariesState): AddressSummariesState {
  return state;
}

export const addressSummariesSelectors = {
  addressSummaries: (state: AddressSummariesState) => _.get(state, 'addressSummaries')
};
